<template>
    <div id="container">
        <!-- <div class="ion-margin">
            <Dropdown v-model="myShip" :options="myShips" optionLabel="name" dataKey="value" placeholder="Filter Ship"
                :required="false" :filter="true" filterPlaceholder="Filter Ship" @change="filterChange()"
                style="width:100%" />
        </div> -->
        <div v-if="logs.length > 0">
            <ion-item class="ion-no-padding" v-for="log of logs" :key="log.id" color="black">
                <ion-grid>
                        <ion-row>
                            <ion-col class="ion-text-left " size="4">Company Name:</ion-col>
                            <ion-col class="ion-text-right" size="8"> {{log.companyName}}</ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col class="ion-text-left " size="4">Client Name:</ion-col>
                            <ion-col class="ion-text-right" size="8"> {{log.clientName}}</ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col class="ion-text-left " size="4">Ship Name:</ion-col>
                            <ion-col class="ion-text-right" size="8"> {{log.shipName}}</ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col class="ion-text-left " size="4">KAM:</ion-col>
                            <ion-col class="ion-text-right" size="8"> {{log.kamName}}</ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col class="ion-text-left " size="4">Created By:</ion-col>
                            <ion-col class="ion-text-right" size="8"> {{log.createdBy}}</ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col class="ion-text-left " size="4">Created At:</ion-col>
                            <ion-col class="ion-text-right" size="8"> {{log.createdAt}}</ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col class="ion-text-left " size="4">Status:</ion-col>
                            <ion-col class="ion-text-right" size="8"> {{log.status}}</ion-col>
                        </ion-row>
                        <ion-row v-if="jsonDecode(log.approvalStatus)">
                            <ion-col class="ion-text-left " size="10">1st Approval(<b>KAM</b>) ({{jsonDecode(log.approvalStatus)['first_approver']['name']}}):</ion-col>
                            <ion-col class="ion-text-right" size="2"> {{jsonDecode(log.approvalStatus)['first_approval']}}</ion-col>
                        </ion-row>
                        <ion-row v-if="jsonDecode(log.approvalStatus)">
                            <ion-col class="ion-text-left " size="10">2nd Approval(<b>HOS</b>)  ({{jsonDecode(log.approvalStatus)['second_approver']['name']}}):</ion-col>
                            <ion-col class="ion-text-right" size="2"> {{jsonDecode(log.approvalStatus)['second_approval']}}</ion-col>
                        </ion-row>
                        <ion-row v-if="jsonDecode(log.approvalStatus)">
                            <ion-col class="ion-text-left " size="10">Final Approval(<b>COO</b>)  ({{jsonDecode(log.approvalStatus)['final_approver']['name']}}):</ion-col>
                            <ion-col class="ion-text-right" size="2"> {{jsonDecode(log.approvalStatus)['final_approval']}}</ion-col>
                        </ion-row>
                        <ion-item class="ion-no-padding">Current Price</ion-item>
                        <ion-row>
                            <ion-col class="ion-text-center " size="3"><small>Device</small></ion-col>
                            <ion-col class="ion-text-center" size="3"><small>Solar</small></ion-col>
                            <ion-col class="ion-text-center" size="3"><small>Installation</small></ion-col>
                            <ion-col class="ion-text-center" size="3"><small>Subscription</small></ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col class="ion-text-center " size="3">{{log.ShipDevicePrice}}</ion-col>
                            <ion-col class="ion-text-center" size="3">{{log.ShipSolarPanelPrice}}</ion-col>
                            <ion-col class="ion-text-center" size="3">{{log.ShipInstallationCharge}}</ion-col>
                            <ion-col class="ion-text-center" size="3">{{log.ShipMonthlySubscriptionFee}}</ion-col>
                        </ion-row>
                        <ion-item class="ion-no-padding " >Request Price</ion-item>
                        <ion-row>
                            <ion-col class="ion-text-center " size="3"><small>Device</small></ion-col>
                            <ion-col class="ion-text-center" size="3"><small>Solar</small></ion-col>
                            <ion-col class="ion-text-center" size="3"><small>Installation</small></ion-col>
                            <ion-col class="ion-text-center" size="3"><small>Subscription</small></ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col class="ion-text-center " size="3">{{log.LogDevicePrice}}</ion-col>
                            <ion-col class="ion-text-center" size="3">{{log.LogSolarPanelPrice}}</ion-col>
                            <ion-col class="ion-text-center" size="3">{{log.LogInstallationCharge}}</ion-col>
                            <ion-col class="ion-text-center" size="3">{{log.LogMonthlySubscriptionFee}}</ion-col>
                        </ion-row>
                        <ion-row v-if="log.status == 'Pending' && log.kamId == user.id && jsonDecode(log.approvalStatus) && jsonDecode(log.approvalStatus)['first_approval'] == 'No'">
                            <ion-col class="ion-text-center " size="6">
                                <ion-button color="success" fill="outline" @click="updateStatus('Approved', log.id,log.shipId)">Approve</ion-button>
                            </ion-col>
                            <ion-col class="ion-text-center" size="6">
                                <ion-button color="danger" fill="outline"  @click="updateStatus('Cancel', log.id,log.shipId)">Cancel</ion-button>
                            </ion-col>
                        </ion-row>
                        <ion-row v-else-if="log.status == 'Pending' && 23 == user.id && jsonDecode(log.approvalStatus) && jsonDecode(log.approvalStatus)['second_approval'] == 'No'">
                            <ion-col class="ion-text-center " size="6">
                                <ion-button color="success" fill="outline" @click="updateStatus('Approved', log.id,log.shipId)">Approve</ion-button>
                            </ion-col>
                            <ion-col class="ion-text-center" size="6">
                                <ion-button color="danger" fill="outline"  @click="updateStatus('Cancel', log.id,log.shipId)">Cancel</ion-button>
                            </ion-col>
                        </ion-row>
                        <ion-row v-else-if="log.status == 'Pending' && 3 == user.id && jsonDecode(log.approvalStatus) && jsonDecode(log.approvalStatus)['final_approval'] == 'No'">
                            <ion-col class="ion-text-center " size="6">
                                <ion-button color="success" fill="outline" @click="updateStatus('Approved', log.id,log.shipId)">Approve</ion-button>
                            </ion-col>
                            <ion-col class="ion-text-center" size="6">
                                <ion-button color="danger" fill="outline"  @click="updateStatus('Cancel', log.id,log.shipId)">Cancel</ion-button>
                            </ion-col>
                        </ion-row>
                </ion-grid>
            </ion-item>
            
        </div>
        <div v-else class="ion-padding ion-text-center">
            No data found
        </div>
         
    </div>
</template>
<script>
    import {
        IonButton,
        IonGrid,
        IonRow,
        IonCol,
        IonItem,
        alertController,
    } from '@ionic/vue';

    export default {
        name: 'AllShip',
        components: {
            IonButton,
            IonGrid,
            IonRow,
            IonCol,
            IonItem,
        },
        data() {
            return {
                logs:[],
                ships: [],
                user:null,
                loading: false,
            }
        },
        created(){
            this.loadData();
        },
        methods: {
            async presentResponseAlert(type, message) {
                const alert = await alertController
                    .create({
                        header: type + '!',
                        // subHeader: 'Subtitle',
                        message: message,
                        buttons: ['OK'],
                    });
                await alert.present();
            },
            async loadData() {
                const data = {
                    'username': window.localStorage.username,
                    'password': window.localStorage.password,
                    'logId': this.$route.params.logId,
                };
                this.loading = true;
                this.$http.post('MyShipPricingLog/MyAllPendingShipsLog', data).then(response => {
                    const logs = [];
                    this.user = response.data.user;
                    for(const log of response.data.logs){
                        const data = JSON.parse(log.data);
                        logs.push({
                            id:log.id,
                            shipId:log.ship_id,
                            kamId:log.kam_id,
                            kamName:log.ship.client.company.kam.name,
                            companyName:log.ship.client.company.company_name,
                            clientName:log.ship.client.client_name,
                            shipName:log.ship.ship_name,
                            status:log.status,
                            approvalStatus:log.approval_status,
                            createdBy:log.created_by.name,
                            createdAt:this.dateFormate(log.created_at,'d-M-Y h:i:s A'),
                            ShipDevicePrice: parseInt(log.ship.device_price),
                            ShipInstallationCharge: parseInt(log.ship.installation_charge),
                            ShipSolarPanelPrice: parseInt(log.ship.solar_panel_price),
                            ShipMonthlySubscriptionFee: parseInt(log.ship.monthly_subscription_fee),
                            LogDevicePrice: parseInt(data.device_price),
                            LogInstallationCharge: parseInt(data.installation_charge),
                            LogSolarPanelPrice: parseInt(data.solar_panel_price),
                            LogMonthlySubscriptionFee: parseInt(data.monthly_subscription_fee),
                            
                        });
                    }
                    this.logs = logs;
                    
                });

            },
            updateStatus (status,id,shipId){
                if(confirm('Are you sure to '+status+' this log?') && (status == 'Approved' || status == 'Cancel')){
                    const data = {
                        'username': window.localStorage.username,
                        'password': window.localStorage.password,
                        'ship_id': shipId,
                        'status':status,
                        'id':id
                    };
                    this.$http.post('MyShipPricingLog/SingleShipLogUpdate',data).then(response => {
                        if(response.data.status){
                            this.loadData();
                        }
                    });
                }
            },
            dateFormate(data, formate) {
                if (!data) {
                    return '';
                }
                const monthsShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct',
                    'Nov', 'Dec'
                ];
                const date = new Date(data);
                let newDate = '';
                const dateFormate = formate.split('');
                for (const field of dateFormate) {
                    if (field == 'd') {
                        if (date.getDate() < 10) {
                            newDate += '0' + date.getDate();
                        } else {
                            newDate += date.getDate();
                        }
                    } else if (field == 'm') {
                        const month = date.getMonth() + 1;
                        if (month < 10) {
                            newDate += '0' + month;
                        } else {
                            newDate += month;
                        }
                    } else if (field == 'M') {
                        newDate += monthsShort[date.getMonth()];
                    } else if (field == 'y') {
                        newDate += date.getFullYear().toString().substr(2);
                    } else if (field == 'Y') {
                        newDate += date.getFullYear();
                    } else if (field == 'H') {
                        if ((date.getHours()) < 10) {
                            newDate += '0' + date.getHours();
                        } else {
                            newDate += date.getHours();
                        }
                    } else if (field == 'h') {
                        let hours = date.getHours();
                        if (date.getHours() > 12) {
                            hours = hours - 12;
                        }
                        if (date.getHours() == 0) {
                            hours = 12;
                        }

                        if (hours < 10) {
                            newDate += '0' + hours;
                        } else {
                            newDate += hours;
                        }
                    } else if (field == 'i') {
                        if (date.getMinutes() < 10) {
                            newDate += '0' + date.getMinutes();
                        } else {
                            newDate += date.getMinutes();
                        }
                    } else if (field == 's') {
                        if (date.getSeconds() < 10) {
                            newDate += '0' + date.getSeconds();
                        } else {
                            newDate += date.getSeconds();
                        }
                    } else if (field == 'A' || field == 'a') {
                        if (date.getHours() > 11) {
                            newDate += field == 'A' ? 'PM' : 'pm';
                        } else {
                            newDate += field == 'A' ? 'AM' : 'am';
                        }
                    } else {
                        newDate += field;
                    }
                }
                return newDate;
            },
            jsonDecode(e) {
                if (e) {
                    const data = JSON.parse(e);
                    return data;
                } else {
                    return false;
                }
            },
            async presentAlert(message) {
                const alert = await alertController
                    .create({
                        header: 'Alert!',
                        // subHeader: 'Subtitle',
                        message: message,
                        buttons: ['OK'],
                    });
                await alert.present();

            },

        },
    }
</script>
